/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  makeStyles,
} from "@material-ui/core";
import { AiOutlineShop, AiOutlineTags } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { setGroupBy } from "./duck/slices";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(1.5),
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  popoverRoot: {
    marginTop: "-5px",
  },
  listRoot: {
    padding: "0px",
  },
  listItem: {
    fontSize: "16px",
    minWidth: "300px",
    padding: "20px",
    "&::before": {
      content: `""`,
      position: "absolute",
      width: "calc(100% - 30px)",
      height: "1px",
      backgroundColor: "#ECEFF1",
      top: "0",
      left: "15px",
    },
    "&:hover": {
      backgroundColor: "#ECEFF1",
      cursor: "pointer",
    },
    "& > :last-child": {
      marginLeft: "10px",
    },
  },
  filterTitleAndIcon: {
    display: "flex",
    alignItems: "center",
  },
  popoverTitle: {
    padding: "20px",
  },
  groupByContainer: {
    display: "flex",
    justifyContent: "start",
    width: "100%",
    padding: "5px 0px",
    "&:hover": {
      cursor: "pointer",
    },
    "& > :last-child": {
      color: theme.palette.primary.main,
      marginLeft: "5px",
    },
  },
}));

const GroupByComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const filtersSlice = useSelector((state) => state.filters);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleGroupByClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (value) => {
    dispatch(setGroupBy(value));
    setAnchorEl(null);
  };

  const handleOnClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        role="presentation"
        onClick={handleGroupByClick}
        className={classes.groupByContainer}
      >
        <Typography variant="body2"> Pricing strategy: </Typography>
        <Typography variant="body2">{filtersSlice.groupBy.label}</Typography>
      </div>
      <Popover
        className={classes.popoverRoot}
        open={Boolean(anchorEl)}
        onClose={handleOnClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box
          component="span"
          className={`${classes.popoverTitle} ${classes.filterTitleAndIcon}`}
        >
          <Typography variant="body1" className={classes.alignCenterFlex}>
            <b>Pricing strategy</b>
          </Typography>
        </Box>
        <List className={classes.listRoot}>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: null,
                label: "By Product-Retailer-Area",
              })
            }
            className={classes.listItem}
          >
            <Typography variant="body1">By Product-Retailer-Area</Typography>
          </ListItem>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: "product",
                label: "By Product",
              })
            }
            className={classes.listItem}
          >
            <AiOutlineTags size={22} />
            <Typography variant="body1">By Product</Typography>
          </ListItem>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: "retailer",
                label: "By Product-Retailer",
              })
            }
            className={classes.listItem}
          >
            <AiOutlineShop size={22} />
            <Typography variant="body1">By Product-Retailer</Typography>
          </ListItem>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: "retailerGroup",
                label: "By Product-Retailer Group",
              })
            }
            className={classes.listItem}
          >
            <AiOutlineShop size={22} />
            <Typography variant="body1">By Product-Retailer Group</Typography>
          </ListItem>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: "area",
                label: "By Product-Area",
              })
            }
            className={classes.listItem}
          >
            <GoLocation size={22} />
            <Typography variant="body1">By Product-Area</Typography>
          </ListItem>
        </List>
      </Popover>
    </>
  );
};

export default GroupByComponent;
